// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._50qirg0 {
  background: var(--_18w76bw25);
  padding: 0 10px;
  margin: 10px 0 20px;
  text-align: center;
  border-bottom: 1px solid var(--_18w76bw28);
  width: 100%;
}
._50qirg2 {
  margin-left: -16px;
  margin-right: -16px;
}
@media screen and (max-width: 767px) {
  ._50qirg0 {
    font-size: var(--_18w76bw3t);
    font-weight: var(--_18w76bw3x);
  }
  ._50qirg1 {
    margin-left: 0;
    margin-right: 0;
    gap: var(--_18w76bwb);
  }
}
@media screen and (min-width: 768px) {
  ._50qirg2 {
    margin-left: 0;
    margin-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":["._50qirg0 {\n  background: var(--_18w76bw25);\n  padding: 0 10px;\n  margin: 10px 0 20px;\n  text-align: center;\n  border-bottom: 1px solid var(--_18w76bw28);\n  width: 100%;\n}\n._50qirg2 {\n  margin-left: -16px;\n  margin-right: -16px;\n}\n@media screen and (max-width: 767px) {\n  ._50qirg0 {\n    font-size: var(--_18w76bw3t);\n    font-weight: var(--_18w76bw3x);\n  }\n  ._50qirg1 {\n    margin-left: 0;\n    margin-right: 0;\n    gap: var(--_18w76bwb);\n  }\n}\n@media screen and (min-width: 768px) {\n  ._50qirg2 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
